import { _ } from "i18n";
import type { Keys } from "i18n/locales/types";

export class DieLigenApiManagementConstants {
	static teamsheetColumns = {
		name: _("video-tasks.modal.teamsheet.table.name" as keyof Keys),
		status: _("video-tasks.modal.teamsheet.table.status" as keyof Keys)
	};

	static columns = {
		eyeballGameId: _("video-tasks.table.header.eyeball_game_id" as keyof Keys),
		videoId: _("video-tasks.table.header.video_id" as keyof Keys),
		matchId: _("video-tasks.table.header.match_id" as keyof Keys),
		gameDate: _("video-tasks.table.header.game_date" as keyof Keys),
		updatedAt: _("video-tasks.table.header.updated_at" as keyof Keys),
		league: _("video-tasks.table.header.league" as keyof Keys),
		leagueCountry: _("video-tasks.table.header.league_country" as keyof Keys),
		category: _("video-tasks.table.header.category" as keyof Keys),
		homeTeam: _("video-tasks.table.header.home_team" as keyof Keys),
		awayTeam: _("video-tasks.table.header.away_team" as keyof Keys),
		videoStatus: _("video-tasks.table.header.video_status" as keyof Keys),
		teamsheetStatus: _("video-tasks.table.header.teamsheet_status" as keyof Keys),
		actions: _("video-tasks.table.header.actions" as keyof Keys),
	};

	static Status = {
		PENDING: "pending",
		NOT_AVAILABLE: "not_available",
		AVAILABLE: "available",
		MAPPED: "mapped",
		NOT_MAPPED: "not_mapped",
		PARTIALLY_MAPPED: "partially_mapped",
		QUEUED: "queued",
		INITIALIZED: "initialized",
		DOWNLOADING: "downloading",
		DOWNLOADED: "downloaded",
		MIGRATED: "migrated",
		HOME_CLUB_NOT_MAPPED: "home_club_not_mapped",
		AWAY_CLUB_NOT_MAPPED: "away_club_not_mapped",
		BOTH_CLUB_NOT_MAPPED: "both_club_not_mapped",
		HOME_TEAM_NOT_MAPPED: "home_team_not_mapped",
		AWAY_TEAM_NOT_MAPPED: "away_team_not_mapped",
		BOTH_TEAM_NOT_MAPPED: "both_team_not_mapped",
		OPTIMIZED: "optimized",
		ERROR: "error",
	};

	static ALL_UNMAPPED = [
		DieLigenApiManagementConstants.Status.NOT_MAPPED,
		DieLigenApiManagementConstants.Status.PARTIALLY_MAPPED,
		DieLigenApiManagementConstants.Status.HOME_CLUB_NOT_MAPPED,
		DieLigenApiManagementConstants.Status.AWAY_CLUB_NOT_MAPPED,
		DieLigenApiManagementConstants.Status.BOTH_CLUB_NOT_MAPPED,
		DieLigenApiManagementConstants.Status.HOME_TEAM_NOT_MAPPED,
		DieLigenApiManagementConstants.Status.AWAY_TEAM_NOT_MAPPED,
		DieLigenApiManagementConstants.Status.BOTH_TEAM_NOT_MAPPED
	];

	static videoStatusOptions = [
		{ value: DieLigenApiManagementConstants.Status.PENDING, label: DieLigenApiManagementConstants.Status.PENDING },
		{ value: DieLigenApiManagementConstants.Status.QUEUED, label: DieLigenApiManagementConstants.Status.QUEUED },
		{ value: DieLigenApiManagementConstants.Status.INITIALIZED, label: DieLigenApiManagementConstants.Status.INITIALIZED },
		{ value: DieLigenApiManagementConstants.Status.DOWNLOADING, label: DieLigenApiManagementConstants.Status.DOWNLOADING },
		{ value: DieLigenApiManagementConstants.Status.DOWNLOADED, label: DieLigenApiManagementConstants.Status.DOWNLOADED },
		{ value: DieLigenApiManagementConstants.Status.MIGRATED, label: DieLigenApiManagementConstants.Status.MIGRATED },
		{ value: DieLigenApiManagementConstants.Status.ERROR, label: DieLigenApiManagementConstants.Status.ERROR },
		{ value: DieLigenApiManagementConstants.Status.OPTIMIZED, label: DieLigenApiManagementConstants.Status.OPTIMIZED },
	];

	static teamsheetStatusOptions = [
		{ value: DieLigenApiManagementConstants.Status.PENDING, label: DieLigenApiManagementConstants.Status.PENDING },
		{ value: DieLigenApiManagementConstants.Status.NOT_AVAILABLE, label: DieLigenApiManagementConstants.Status.NOT_AVAILABLE },
		{ value: DieLigenApiManagementConstants.Status.AVAILABLE, label: DieLigenApiManagementConstants.Status.AVAILABLE },
		{ value: DieLigenApiManagementConstants.Status.MAPPED, label: DieLigenApiManagementConstants.Status.MAPPED },
		{ value: DieLigenApiManagementConstants.Status.NOT_MAPPED, label: DieLigenApiManagementConstants.Status.NOT_MAPPED },
		{ value: DieLigenApiManagementConstants.Status.PARTIALLY_MAPPED, label: DieLigenApiManagementConstants.Status.PARTIALLY_MAPPED },
		{ value: DieLigenApiManagementConstants.Status.HOME_CLUB_NOT_MAPPED, label: DieLigenApiManagementConstants.Status.HOME_CLUB_NOT_MAPPED },
		{ value: DieLigenApiManagementConstants.Status.AWAY_CLUB_NOT_MAPPED, label: DieLigenApiManagementConstants.Status.AWAY_CLUB_NOT_MAPPED },
		{ value: DieLigenApiManagementConstants.Status.BOTH_CLUB_NOT_MAPPED, label: DieLigenApiManagementConstants.Status.BOTH_CLUB_NOT_MAPPED },
		{ value: DieLigenApiManagementConstants.Status.HOME_TEAM_NOT_MAPPED, label: DieLigenApiManagementConstants.Status.HOME_TEAM_NOT_MAPPED },
		{ value: DieLigenApiManagementConstants.Status.AWAY_TEAM_NOT_MAPPED, label: DieLigenApiManagementConstants.Status.AWAY_TEAM_NOT_MAPPED },
		{ value: DieLigenApiManagementConstants.Status.BOTH_TEAM_NOT_MAPPED, label: DieLigenApiManagementConstants.Status.BOTH_TEAM_NOT_MAPPED },
	];

	static teamsheetPlayerStatus = {
		notMapped: DieLigenApiManagementConstants.Status.NOT_MAPPED,
		mapped: DieLigenApiManagementConstants.Status.MAPPED,
	};
}
